import { useEffect, useState } from "react";
import {
  getPropertiesById,
  getSimilarProperties,
  getSimilarPropertiesByPrice,
} from "../../../services/propertyService";

export const usePropertyDetail = (id) => {
  const [property, setProperty] = useState(null);
  const [similarProperties, setSimilarProperties] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;

    const fetchData = async () => {
      try {
        setLoading(true);

        const data = await getPropertiesById(id);

        setProperty(data);

        let similar = await getSimilarProperties(data.brand);

        similar = similar
          .filter((c) => c.id.toString() !== id.toString())
          .slice(0, 4);

        if (similar.length === 0) {
          similar = await getSimilarPropertiesByPrice(data.price);

          similar = similar
            .filter((c) => c.id.toString() !== id.toString())
            .slice(0, 4);
        }

        setSimilarProperties(similar);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  return {
    property,
    similarProperties,
    loading,
  };
};